import axiosInstance from "../../utils/config/config";

export const getAllConversations = (userId) => async (dispatch) => {
  try {
    dispatch({
      type: "getAllConvoRequest",
    });
    const { data } = await axiosInstance.get(
      `/conversation/getConversations?userId=${userId}`
    );
    dispatch({
      type: "getAllConvoSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllConvoFailure",
      payload: true,
    });
  }
};
